module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default", null, null, this), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 25, 50, 100, 200, '所有'],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "current-change": _vm.onCurrentChange,
      "size-change": _vm.onPageSize
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d24a6ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/filterPageList.vue
// module id = 1414
// module chunks = 1